// ── Derive downstream config from the Workflow Builder's selected workflow ────
//
// Once a rep has picked/opened a workflow in the Workflow Builder slate, later
// slates (KYC + Cascade, IDV & Biometrics) shouldn't ask them to re-pick the same
// thing — this walks that workflow's task tree to surface what it already implies.
import { isBranchTask, isStepTask } from '@features/dashboards/components/OpsCenterMockup/types'
import type { Task, Workflow } from '@features/dashboards/components/OpsCenterMockup/types'

export interface DerivedKycStep {
  provider?: string
  ruleset?: string
}

export interface WorkflowDerivedConfig {
  workflowName: string
  workflowVersion: number
  hasIdvStep: boolean
  kycSteps: DerivedKycStep[]
}

function walk(tasks: Task[], kycSteps: DerivedKycStep[], onIdv: () => void) {
  for (const t of tasks) {
    if (isStepTask(t)) {
      const name = t.configuration.name
      const params = t.configuration.parameters ?? {}
      if (name === 'IDV') onIdv()
      if (name === 'KYC') {
        kycSteps.push({
          provider: typeof params.providerName === 'string' ? params.providerName : undefined,
          ruleset: typeof params.rulesetName === 'string' ? params.rulesetName : undefined,
        })
      }
    } else if (isBranchTask(t)) {
      t.configuration.branches.forEach((b) => walk(b.tasks, kycSteps, onIdv))
    }
  }
}

export function deriveConfigFromWorkflow(workflow: Workflow): WorkflowDerivedConfig {
  const kycSteps: DerivedKycStep[] = []
  let hasIdvStep = false
  walk(workflow.tasks, kycSteps, () => { hasIdvStep = true })
  return { workflowName: workflow.name, workflowVersion: workflow.version, hasIdvStep, kycSteps }
}
